module.exports = __webpack_public_path__ + "img/ic_hamro_correct.98c1bbf5.svg";